import useSocket from 'tennders-common/hooks/useSocket'
import { useEffect } from 'react'
import { useDebounce } from 'use-debounce'

export const withSocket = (WrappedComponent) => ({ onRefresh, refreshKey, ...rest }) => {
  const { refresh } = useSocket()
  const [debouncedRefresh] = useDebounce(refresh, 1000)

  console.info('push refresh', refresh)
  useEffect(() => {
    if (debouncedRefresh === refreshKey || debouncedRefresh === 'all') {
      onRefresh()
    }
  }, [debouncedRefresh])

  useEffect(() => {
    if (refresh === 'fast') {
      onRefresh()
    }
  }, [refresh])

  return <WrappedComponent {...rest} />
}
